import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import czTranslations from './locales/cs.json';
import enTranslations from './locales/en.json';

const resources = {
  cs: {
    translation: czTranslations,
  },
  en: {
    translation: enTranslations,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'cs',
    fallbackLng: 'cs',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;

//i18n.changeLanguage('en')
